export const CTA_TEXT = "Set Image";
export const WRONG_FILE_TYPE_ALERT = "That's not an Image 😠 Try again!";
